import PropTypes from 'prop-types';
import { Box, FormControl, TextField, InputLabel } from '@mui/material';
import { useTableProvider } from 'contexts/TableProvider';

const GeoAreaFilter = (props) =>
{
   const {
      disabled = false,
      label,
      name,
      visible,
      cityKey = 'city',
      kmKey = 'km',
      cityLabel = 'Citta',
      kmLabel = 'Km',
   } = props;

   const {
      customQuery,
      setCustomQuery
   } = useTableProvider();

   const handleChange = (key, value) =>
   {
      setCustomQuery({ ...customQuery, [key]: value });
   };

   return (
      <FormControl
         fullWidth
         variant="outlined"
         size="small"
      >
         {label && <InputLabel shrink htmlFor={name}>{label}</InputLabel>}
         <Box
            sx={{
               display: 'flex'
            }}
         >
            <TextField
               fullWidth
               variant="outlined"
               size="small"
               disabled={!visible || disabled}
               label={cityLabel}
               value={customQuery[cityKey] || ''}
               onChange={(e) => handleChange(cityKey, e.target.value)}
               id={cityKey}
               name={cityKey}
               sx={{
                  marginRight: '-1px',
                  '& .MuiInputBase-root': {
                     borderTopRightRadius: 0,
                     borderBottomRightRadius: 0
                  }
               }}
               InputLabelProps={{
                  shrink: true,
               }}
            />
            <TextField
               variant="outlined"
               size="small"
               type="number"
               disabled={!visible || disabled}
               label={kmLabel}
               value={customQuery[kmKey] || ''}
               onChange={(e) => handleChange(kmKey, e.target.value)}
               id={kmKey}
               name={kmKey}
               sx={{
                  width: 120,
                  '& .MuiInputBase-root': {
                     borderTopLeftRadius: 0,
                     borderBottomLeftRadius: 0
                  }
               }}
               InputLabelProps={{
                  shrink: true,
               }}
               inputProps={{
                  min: 0
               }}
            />
         </Box>
      </FormControl>
   );
};

GeoAreaFilter.propTypes = {
   cityKey: PropTypes.string,
   cityLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
   disabled: PropTypes.bool,
   id: PropTypes.string,
   kmKey: PropTypes.string,
   kmLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
   label: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
   name: PropTypes.string,
   visible: PropTypes.bool
};

export default GeoAreaFilter;
